import "core-js/modules/es.string.trim.js";
// const commentParams = { 'filter[thread]': '', sort: 'createdAt', page: 1, perPage: 20, index: 1 }
var params = {
  isComment: 1,
  id: '',
  content: '',
  replyId: '',
  commentPostId: ''
};
import { postComments, thumbs, signalComment } from '@/api/mg';
export default {
  watch: {
    show: function show() {
      this.itm.isSelected = this.show;
      // if (!this.show) {
      //   this.itm = ''
      // }
    }
  },
  data: function data() {
    return {
      commentData: {},
      pid: '',
      title: 'Comments',
      show: false,
      placeholder: this.$t('ssthing'),
      isEmpty: true,
      isFocus: false,
      isFollow: true,
      inputValue: '',
      threadId: '',
      userId: '',
      storeUserId: '',
      confirmTextShow: false,
      showCommentBack: true
    };
  },
  created: function created() {
    this.storeUserId = localStorage.getItem('userId');
    this.showCommentBack = !this.$route.query.showCommentBack;
    this.pid = this.$route.query.pid;
    this.threadId = this.$route.query.threadId;
    var params = {
      pid: this.pid
    };
    this.getComment(params);
  },
  mounted: function mounted() {},
  methods: {
    delComments: function delComments() {
      this.confirmTextShow = true;
    },
    cancelTextHandler: function cancelTextHandler() {
      this.confirmTextShow = false;
      this.item.isSelected = false;
    },
    confirmOKHandler: function confirmOKHandler() {
      var params = {
        pid: this.delPid,
        data: {
          attributes: {
            isDeleted: true
          }
        }
      };
      this.thumpsApi(params, 'delete');
    },
    del: function del() {
      var params = {
        pid: this.delPid,
        data: {
          attributes: {
            isDeleted: true
          }
        }
      };
      this.thumpsApi(params, 'delete');
    },
    cancel: function cancel() {
      this.show = false;
    },
    start: function start(userId, pid, itm) {
      this.blur();
      this.userId = userId;
      this.delPid = pid;
      this.itm = itm;
    },
    longpress: function longpress() {
      console.log('进入langPress', localStorage.getItem('userId'), this.userId);
      if (localStorage.getItem('userId') === this.userId + '') {
        this.show = true;
      }
    },
    thumbsUp: function thumbsUp(pid, isLike, threadId) {
      if (threadId) {
        var _params = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid,
          id: threadId
        };
        this.thumpsApi(_params, 'thread');
      } else {
        var _params2 = {
          data: {
            attributes: {
              isLiked: !isLike
            }
          },
          pid: pid
        };
        this.thumpsApi(_params2, 'comment');
      }
    },
    thumpsApi: function thumpsApi(params, type) {
      var _this = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (type === 'delete') {
            _this.show = false;
            _this.confirmTextShow = false;
            console.log(_this.delPid, _this.pid, 'sdfsdf');
            if (_this.delPid + '' === _this.pid || _this.commentData.commentPosts.length == 1) {
              _this.$router.back();
            }
            _this.getComment({
              pid: _this.pid
            });
          }
          if (type === 'comment') {
            _this.getComment({
              pid: _this.pid
            });
          }
          if (type === 'thread') {
            var _params3 = {
              threadId: _this.threadId
            };
            _this.getDetail(_params3);
          }
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toReply: function toReply(name, replyId, commentPostId) {
      this.$refs.inputs.focus();
      params.replyId = replyId;
      if (commentPostId) {
        params.commentPostId = commentPostId;
      } else {
        params.commentPostId = '';
      }
      console.log(params, 'params');
      this.placeholder = this.$t('rely') + ' ' + name + ':';
    },
    post: function post(params) {
      var _this2 = this;
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      postComments(params).then(function (res) {
        if (res.Code === 0) {
          params.replyId = _this2.pid;
          params.commentPostId = '';
          _this2.placeholder = _this2.$t('ssthing'), _this2.itm = '';
          res.Data.lastThreeComments = [];
          _this2.commentData.commentPosts.unshift(res.Data);
          // this.getComment({ pid: this.pid })
        } else {
          _this2.$toast(res.Message);
          var _params4 = {
            threadId: _this2.threadId
          };
          _this2.getDetail(_params4);
        }
      });
    },
    send: function send() {
      if (this.inputValue.trim()) {
        if (params.replyId) {
          params.content = this.inputValue;
          params.id = this.threadId;
          this.post(params);
        } else {
          // const params1 = { id: this.threadId, content: this.inputValue.trim() }
          // this.post(params1)
          this.$toast('replyId不存在');
        }
        this.isFocus = false;
        this.inputValue = '';
        this.isEmpty = true;
      }
    },
    input: function input(val) {
      if (val.trim()) {
        this.isEmpty = false;
      } else {
        this.isEmpty = true;
      }
    },
    blur: function blur() {
      if (!this.inputValue) {
        this.isFocus = false;
        this.$refs.inputs.blur();
        params.replyId = this.pid;
        params.commentPostId = '';
        this.placeholder = this.$t('ssthing'), this.itm = '';
      }
      // this.isFocus = false
      // this.inputValue = ''
      // this.isEmpty = true
    },
    focus: function focus() {
      this.isFocus = true;
      this.$refs.inputs.focus();
    },
    getComment: function getComment(params1) {
      var _this3 = this;
      signalComment(params1).then(function (res) {
        if (res.Code === 0) {
          _this3.commentData = res.Data;
          params.replyId = _this3.commentData.id;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    back: function back() {
      var _this4 = this;
      var timer = setTimeout(function () {
        _this4.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  }
};